<template>
    <div>
        <Header/>
        <div class="container mt-3">
            <div class="row" v-for="article in newArticles" :key="article.index">
                <div class="col-md-6">
                    <img :src="getImgNewArticle(article.path_file)" class="img-fluid">
                </div>
                <div class="col-md-6 bg-white rounded p-2" data-aos="fade-left">
                    <h4 class="text-bold">{{article.article_name}}</h4>
                    <p class="text-gray text-10"><i class="fas fa-calendar-day"></i> {{ moment(article.created_at).locale('th').format('lll') }}</p>
                    <span class="text-gray" v-html="text(article.article_detail)"></span>
                    <router-link :to="linkNewArticle(article.article_id)" class="btn btn-order text-white">อ่านเพิ่มเติม</router-link>
                </div>
            </div><hr>
            <div class="row">
                <div class="col-lg-4 bordered mb-3" v-for="article in articles" :key="article.index">
                    <div class="card mb-5 mb-lg-0" data-aos="zoom-in" :title="titleText(article.article_name)">
                        <img :src="getImgNewArticle(article.path_file)" class="card-img-top">
                        <div class="article-caption bg-light p-2 w-100">
                            <router-link :to="'articleDetail/'+article.article_id"><i class="fas fa-scroll text-danger"></i> {{subText(article.article_name)}}</router-link><br>
                            <span class="text-gray text-10"><i class="fas fa-clock"></i> {{moment(article.created_at).locale('th').format('lll')}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <br><br><br><br>
        <Footer/>
    </div>
</template>

<script>
var moment = require('moment')
import Header from '../components/Header'
import Footer from '../components/Footer'
    export default {
        components: {
            Header,Footer,
        },
        data(){
            return {
                newArticles:{},
                moment:moment,
                articles:{},
            }
        },
        methods:{
            newArticle(){
                this.axios.get('http://pgm01.toonjob.com/2019/BannKlong/project/newArticle')
                .then((response) => {
                    this.newArticles = response.data
                })
            },
            getImgNewArticle(img){
                let image = 'http://pgm01.toonjob.com/2019/BannKlong/image/articles/'+img
                return image
            },
            linkNewArticle(id){
                let link = '/articleDetail/'+id
                return link
            },
            allArticles(){
                this.axios.get('http://pgm01.toonjob.com/2019/BannKlong/project/dataArticle')
                .then((response) => {
                    this.articles = response.data
                })
            },
            text(text){
                let message = text.substring(0,600)+'...'
                return message
            },
            subText(text){
                let message = text.substring(0,35)+'...'
                return message
            },
            titleText(text){
                let message = text
                return message
            }
        },
        created(){
            this.$Progress.start()
            this.newArticle()
            this.allArticles()
            this.$Progress.finish()
        }
    }
</script>



// WEBPACK FOOTER //
// src/frontEnd/ArticlePage.vue